import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Check, AlertCircle, ChevronRight } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
type Role = 'learner' | 'parent' | 'teacher';
interface RegisterNameStepProps {
  role: Role;
  name: string;
  onNameChange: (value: string) => void;
  usernameAvailable: boolean;
  suggestedUsername: string;
  slideVariants: Record<string, unknown>;
}
export function RegisterNameStep({
  role,
  name,
  onNameChange,
  usernameAvailable,
  suggestedUsername,
  slideVariants
}: RegisterNameStepProps) {
  return <motion.div key="step-name" custom={1} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
    duration: 0.3
  }} className="space-y-5" data-id="element-388" data-mp="26ga2vhwq3lu6">
      <h2 className="text-xl font-black text-slate-900 text-center" data-id="element-389" data-mp="nbg0t3d69h2">
        {role === 'learner' ? 'Hoe heet je?' : 'Wat is je naam?'}
      </h2>

      <div data-id="element-390" data-mp="24nz7tjev8ann">
        <label className="block text-sm font-bold text-slate-600 mb-1.5" data-id="element-391" data-mp="24o905dndutwi">
          {role === 'learner' ? 'Voornaam' : 'Volledige naam'}
        </label>
        <div className="relative" data-id="element-392" data-mp="1vpdwa87t9vwd">
          <Input type="text" required autoFocus value={name} onChange={e => onNameChange(e.target.value)} icon={<User className="w-5 h-5" data-id="element-394" data-mp="2nh33fabn8xkw" />} className="bg-slate-50 border-2 border-slate-200 rounded-2xl focus:bg-white focus:border-orange-400 text-lg font-medium py-4" placeholder={role === 'learner' ? 'bijv. Djayden' : 'bijv. Jan de Vries'} data-id="element-393" data-mp="1vqgja520je70" />
        </div>
      </div>

      {/* Username preview for learners */}
      <AnimatePresence data-id="element-395" data-mp="36f5yo6usbqr5">
        {role === 'learner' && name.trim() && <motion.div initial={{
        opacity: 0,
        y: -10,
        height: 0
      }} animate={{
        opacity: 1,
        y: 0,
        height: 'auto'
      }} exit={{
        opacity: 0,
        y: -10,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-396" data-mp="36d302yfkgpat">
            <div className={`p-4 rounded-2xl border flex items-start gap-3 mt-2 ${usernameAvailable ? 'bg-orange-50 border-orange-100' : 'bg-red-50 border-red-200'}`} data-id="element-397" data-mp="371ligvt39h48">
              <div className={`mt-0.5 ${usernameAvailable ? 'text-orange-500' : 'text-red-500'}`} data-id="element-398" data-mp="2xah15pfxxk68">
                {usernameAvailable ? <Check className="w-5 h-5" data-id="element-399" data-mp="2ocewmzx009e7" /> : <AlertCircle className="w-5 h-5" data-id="element-400" data-mp="2jbzl8dwa1byv" />}
              </div>
              <div data-id="element-401" data-mp="2ed666h1cdcwl">
                <p className={`text-sm font-medium ${usernameAvailable ? 'text-orange-800' : 'text-red-800'}`} data-id="element-402" data-mp="2eco1qx4izsdl">
                  {usernameAvailable ? 'Je gebruikersnaam wordt:' : 'Deze naam is al bezet:'}
                </p>
                <p className={`text-lg font-black mt-0.5 ${usernameAvailable ? 'text-orange-600' : 'text-red-600'}`} data-id="element-403" data-mp="2e6vts9pbh9zr">
                  {suggestedUsername}
                </p>
                <p className={`text-xs mt-1 ${usernameAvailable ? 'text-orange-600/70' : 'text-red-600/70'}`} data-id="element-404" data-mp="1ljj6fxbc0y5e">
                  {usernameAvailable ? 'Hiermee log je straks in.' : 'Probeer een andere naam of voeg je achternaam toe.'}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <Button type="submit" variant="primary" size="lg" className="w-full" disabled={!name.trim() || role === 'learner' && !usernameAvailable} data-id="element-405" data-mp="12rgswutzlxzd">
        Verder <ChevronRight className="w-5 h-5 ml-1" data-id="element-406" data-mp="39h230hccgfjp" />
      </Button>
    </motion.div>;
}